import { VideoUIChat } from "./VideoUIChat";
import { useChatVisibility } from "@platform/features/chat/hooks/useChatVisibility";

export function VideoUIChatContainer() {
  const { shouldShowChat, isLoading } = useChatVisibility();

  // Don't render chat if disabled or still loading
  if (isLoading || !shouldShowChat) {
    return null;
  }

  return <VideoUIChat />;
}

export default VideoUIChatContainer;
